import { render, staticRenderFns } from "./opinionEdit.vue?vue&type=template&id=3d41e1cc&scoped=true&"
import script from "./opinionEdit.vue?vue&type=script&lang=js&"
export * from "./opinionEdit.vue?vue&type=script&lang=js&"
import style0 from "./opinionEdit.vue?vue&type=style&index=0&id=3d41e1cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d41e1cc",
  null
  
)

export default component.exports